export const initialState = () => ({
  loading: {
    message: "",
    show: false
  },

  visitFlow: {
    name: "",
    icon: "",
    flows: [],
  },

  isEditing: false,
  uuid: ""
})